import request from '@/config/axios'

export interface AiCsFaqItem {
  q: string
  a?: string
  /** 触发关键词，逗号分隔或数组序列化后写入 faqJson */
  keywords?: string
}

export interface AiCsSceneVO {
  id?: number
  sceneCode: string
  name: string
  enabled: boolean
  knowledgeId?: number
  modelId?: number
  systemPrompt?: string
  welcomeText?: string
  transferKeywords?: string
  lowConfidenceTransfer?: boolean
  confThreshold?: number
  fallbackText?: string
  channelHint?: string
  /** 快捷问题 JSON 字符串，或由前端用 faqItems 序列化 */
  faqJson?: string
  /** 多轮话术流 JSON */
  scriptFlowJson?: string
}

export const AiCsSceneApi = {
  list: () => request.get({ url: '/ai/cs/scene/list' }),
  get: (id: number) => request.get({ url: '/ai/cs/scene/get', params: { id } }),
  create: (data: AiCsSceneVO) => request.post({ url: '/ai/cs/scene/create', data }),
  update: (data: AiCsSceneVO) => request.put({ url: '/ai/cs/scene/update', data })
}
